module.exports = __webpack_public_path__ + "img/googlenews.c9b32b88.png";